<template>
  <landing-page @auth="openAuth" />
</template>

<script>
// Public marketing landing page, rendered as Vue components.
//
// Previously this was public/landing/index.html in a full-screen iframe. The
// markup, styles and widgets now live under ./landing/ so the page shares the
// app's bundle and its login modal. The iframe version is kept on the
// 'landing-iframe-savepoint' branch.
//
// Routing: '/' and '/login' both render this page with meta.bare, so App.vue
// hides the navbar and sidebar. Arriving at /login while logged out opens the
// login modal; a successful login continues to /dashboard.
//
// Sign-up: App.vue's navbar, which this page hides, is where the Register
// link used to be. The page's Get Adverpost and Create account buttons now
// open that same register modal instead.
import LandingPage from "./landing/LandingPage.vue";

export default {
  name: "Landing",
  components: { LandingPage },
  mounted() {
    this.syncLoginModal();
  },
  watch: {
    $route() {
      this.syncLoginModal();
    },
  },
  methods: {
    // Open the app's existing login or register modal directly, instead of
    // the iframe's old trick of linking to /#/dashboard and letting the auth
    // guard bounce the request back to /login. Someone already signed in goes
    // straight to the dashboard either way.
    openAuth(kind) {
      if (this.$auth.user.authenticated) {
        this.$router.push("/dashboard").catch(() => {});
        return;
      }
      this.$bvModal.show(kind === "register" ? "register" : "login");
    },
    syncLoginModal() {
      if (this.$route.path === "/login" && !this.$auth.user.authenticated) {
        this.$nextTick(() => this.$bvModal.show("login"));
      }
    },
  },
};
</script>
